<template>
    <div>
        <div class="filter-shadow" @click="showDropdown = false" v-if="showDropdown"></div>
        <button class="filter-button" @click="showDropdown = !showDropdown" :class="{'active' : showDropdown}">
            Filter
            <svg class="filters"><use xlink:href="#filters"></use></svg>
        </button>
        <div class="filter-dropdown" :class="{'active' : showDropdown}">
            <button v-for="(option, index) in options"
                    class="dropdown-item"
                    :class="{'active' : (currentFilter == option.key || (currentFilter == null && option.key == 'all'))}"
                    :key="`filter-${index}`"
                    @click="filterBy(option)">
                {{ option.label }}
            </button>
        </div>
    </div>
</template>
<script>
export default {

    props:['options'],

    data() {
        return {
            currentFilter: null,
            showDropdown: false,
        }
    },

    created(){
        let params = new URLSearchParams(window.location.search)
        if(params.has("filter")) {
            this.currentFilter = params.get("filter")
        }
    },

    methods: {
        filterBy(option) {
            this.currentFilter = option.key
            window.location.href = `/lists?filter=${option.key}`;
        }
    }
}
</script>
